import EventEmitter from 'eventemitter3';

var globalEventBusSingleton = function () {
  window.__pxlGlobalEventBus__ = window.__pxlGlobalEventBus__ || null;
  return {
    getInstance: function getInstance() {
      if (!window.__pxlGlobalEventBus__) {
        window.__pxlGlobalEventBus__ = new EventEmitter();
      }

      return window.__pxlGlobalEventBus__;
    }
  };
}();

export var globalEventBus = globalEventBusSingleton.getInstance();
export var globalEventBusPlugin = {
  install: function install(Vue) {
    Vue.prototype.$globalEventBus = globalEventBusSingleton.getInstance();
  }
};